<template>
	<div>
		<c-table v-if="data" :value="data" skin="detail">
			<c-table-column
				label="状态"
				width="100"
			>
				<template v-slot="{data}">
					<span v-if="insuranceState[data.state]" :style="{'color': insuranceState[data.state].color}">
						<i class="tf" style="margin-right: 6px;">{{insuranceState[data.state].icon}}</i>{{insuranceState[data.state].name}}
					</span>
				</template>
			</c-table-column>
			
			<c-table-column
				label="保函类型"
				name="bx_type_name"
				width="160"
			></c-table-column>
			
			<c-table-column
				label="被保险人"
				name="bbxr_name"
				width="230"
			></c-table-column>
			
			<c-table-column
				label="保单额度"
				width="120"
			>
				<template v-slot="{data}">
					<span v-if="data.bd_money">￥{{data.bd_money}}</span>
				</template>
			</c-table-column>
			
			<c-table-column
				label="金融机构"
				name="bxgs_name"
				width="230"
			></c-table-column>
			
			<c-table-column
				label="保单有效期限"
				width="200"
			>
				<template v-slot="{data}">
					<div v-if="data.bx_bd_state_date">
						<p>{{data.bx_bd_state_date}}至{{data.bx_bd_end_date}}</p>
						<p v-if="data.exp_date >= 0" style="color: #f00;">（还有{{data.exp_date}}天）</p>
						<p v-else style="color: #f00;">（已过期）</p>
					</div>
				</template>
			</c-table-column>
			
			<c-table-column
				v-if="power('7')"
				label="操作"
				width="130"
			>
				<template v-slot="{data}">
					<underwrite v-if="data.state == 0" :project-id="projectId" :type="data.bx_type_id">我要办理</underwrite>
					<c-button v-else-if="data.state == 1" @click="navigateTo('/transact/insurance/apply', {id: data.id}, true)">继续办理</c-button>
					<c-button v-else-if="data.state == 2" @click="paymentHandle(data)">上传付款凭证</c-button>
					<c-button v-else-if="data.state == 5" @click="navigateTo('/transact/insurance/apply', {id: data.id}, true)">重新办理</c-button>
					<c-button v-else @click="navigateTo('/transact/insurance/detail', {id: data.id}, true)">查看详情</c-button>
				</template>
			</c-table-column>
		</c-table>
		<payment ref="payment" @resolve="paymentSuccess"></payment>
	</div>
</template>

<script>
	import underwrite from '@/components/module/underwrite.vue'
	import payment from './insurance_payment.vue'
	import {mapGetters} from 'vuex'
	
	export default {
		components: {
			underwrite,
			payment
		},
		
		props: {
			projectId: [String, Number],
			data: Array
		},
		
		computed: {
			...mapGetters(['power', 'insuranceState'])
		},
		
		methods: {
			paymentHandle(data) {
				this._payment = data;
				this.$refs.payment.open(data.id);
			},
			
			paymentSuccess() {
				this._payment.state = 3;
			}
		}
	}
</script>